export const DEFAULT_ACTION_MENU_ADD = 'add';
export const DEFAULT_ACTION_MENU_CREATE = 'create';
export const DEFAULT_ACTION_MENU_UPDATE = 'update';
export const DEFAULT_ACTION_MENU_DETAILS = 'details';
export const DEFAULT_ACTION_MENU_DETAIL = 'detail';
export const DEFAULT_ACTION_MENU_REGULAR = 'regular';
export const DEFAULT_ACTION_MENU_DELETE = 'delete';
